export const bartBlueLineExt = [
    [37.68948278233216, -122.11574257917168],
    [37.68900276931877, -122.11459656525881],
    [37.68867374381149, -122.11340284233887],
    [37.68859483321871, -122.11213501359094],
    [37.688609696897764, -122.11038067167866],
    [37.68874673877349, -122.10911241423189],
    [37.6895633626796, -122.10204513829093],
    [37.69029494474427, -122.09579995723153],
    [37.69051140136239, -122.09310751865368],
    [37.69063460530984, -122.0898167244428],
    [37.6907194759882, -122.07574624707654], // BART Castro Valley
    [37.690774001384135, -122.07176611500932],
    [37.69101719252275, -122.0692969073979],
    [37.69174139460347, -122.06599458634719],
    [37.69346290820961, -122.05995990500455],
    [37.693711113978885, -122.05819052783515],
    [37.6937601163714, -122.0560725719657],
    [37.693657563801054, -122.05526560031846],
    [37.69343339790476, -122.05294497446158],
    [37.69339268273277, -122.0515737698473],
    [37.693591123037194, -122.04975658368018],
    [37.69407669901379, -122.04796412633819],
    [37.69530623029585, -122.04548218924849],
    [37.69655242322911, -122.04387289740431],
    [37.69971529845152, -122.04043885422591],
    [37.70038725819804, -122.03952655485345],
    [37.70133603785168, -122.03756959075898],
    [37.70187966868101, -122.0355697060341],
    [37.70214657948674, -122.03323940395167],
    [37.70195684868256, -122.03090115283074],
    [37.70165670715235, -122.02949731379827],
    [37.70112936353711, -122.02751012774031],
    [37.700811177973335, -122.02543650262486],
    [37.700909504329374, -122.02338862644184],
    [37.70125903494084, -122.02137733631491],
    [37.70210447818898, -122.01892030779244],
    [37.70254396494843, -122.01757855762567],
    [37.7029244882116, -122.01511474910777],
    [37.70297099274298, -122.0139660205845],
    [37.7035159943494, -122.00203580684045],
    [37.70341134156498, -121.99920250106311],
    [37.70303327685895, -121.99679298467166],
    [37.70264088782867, -121.99530482168939],
    [37.70181088628909, -121.99286779507581],
    [37.70149113159229, -121.99205855981522],
    [37.7005854741724, -121.99001161508019],
    [37.70018020305129, -121.98885979868699],
    [37.69984272409062, -121.9877964202625],
    [37.69961569178494, -121.98635215678522],
    [37.699367378128485, -121.98402209137782],
    [37.69915565512483, -121.98225574807861],
    [37.697587109515545, -121.97335892386428],
    [37.69740655619657, -121.97183142664207],
    [37.69719438292602, -121.96857758055732],
    [37.69733594850959, -121.96555431170897],
    [37.69759202039558, -121.96300160002164],
    [37.69834862928412, -121.95876609019845],
    [37.698444851113294, -121.95749735278025],
    [37.69845205556402, -121.95693687478504],
    [37.69828947790926, -121.93634036064906],
    [37.69845230287545, -121.93403019610135],
    [37.69893661891014, -121.93176334514685],
    [37.69965248172238, -121.92831688583986], // BART West Dublin/Pleasanton
    [37.701635140545136, -121.91975133905616],
    [37.70179104739952, -121.91807998390476],
    [37.701843025549394, -121.9163771133884],
    [37.70161431134461, -121.89948958319154], // BART Dublin / Pleasanton
];